const AppConfig = {
	name: 'PWR Airdrop',
	version: '1.1.0',
	description: '',
	favIcon: '/assets/images/favicon.png',
};

export default AppConfig;
